import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdOperationsGeneralConfiguration } from '@jira/navigation-apps__constants/src/SidebarIdOperationsGeneralConfiguration.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocAlertIssueSyncingCreateRoute } from '@jira/router-routes__eoc-alert-issue-syncing-routes/src/eocAlertIssueSyncingCreateRoute.tsx';
import { LazySidebarContent } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-operations/src/ui/index.tsx';
import { resources as alertIssueSyncingResources } from '@atlassian/eoc-alert-issue-syncing/resources';
import type { Route } from '@atlassian/react-resource-router';
import { AlertIssueSync } from './ui/AlertIssueSync.tsx';
import { AlertIssueSyncCreate } from './ui/AlertIssueSyncCreate.tsx';
import { LazyAlertIssueSync } from './ui/async.tsx';

const getNavigationSpecifications = () => {
	return {
		sidebarId: SidebarIdOperationsGeneralConfiguration,
	};
};

export const eocAlertIssueSyncingCreateRouteEntry: Route = createEntry(
	eocAlertIssueSyncingCreateRoute,
	() => ({
		group: 'eoc',
		// eslint-disable-next-line no-restricted-syntax
		component: AlertIssueSync,
		slot: AlertIssueSyncCreate,
		basePath: '/jira/settings/products/ops',

		resources: [
			...getNavigationResources(),
			...getNavigationSidebarProductsSettingResource(),
			alertIssueSyncingResources.configuredSyncsResource,
			alertIssueSyncingResources.userAccessRightsResource,
		],

		navigation: {
			menuId: MenuIdSettings,
			...getNavigationSpecifications(),
		},

		forPaint: [LazySidebarContent, LazyAtlassianNavigation, LazyAlertIssueSync],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
